// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:15
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class ResourceTypeManagerData_abstract extends BaseObject {
  static $t: string = 'SagaSchema.ResourceTypeManagerData';
  $t: string = 'SagaSchema.ResourceTypeManagerData';

  public static GetMembers(): string[] {
    return ['EngagementUID', 'Requests', 'UnSectorized', 'XmlDataString'];
  }

  public GetMembers(): string[] {
    return ResourceTypeManagerData_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public EngagementUID: Guid = GuidTools.Empty;
  public Requests: any[];
  public UnSectorized: boolean = false;
  public XmlDataString: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
